import Dexie from "dexie";

export const offlineDB = new Dexie("retail-pos-db");

// OLD VERSION (DO NOT CHANGE)
offlineDB.version(1).stores({
  products: "product_id",
  inventory: "++id, product_id, branch_id",
  invoices: "++id, synced",
  branches: "branch_id",
  meta: "key"
});

// NEW VERSION (ADD ONLY — DO NOT MODIFY OLD)
offlineDB.version(2).stores({
  inventory_v2: "[branch_id+product_id]",
});
